import { render, staticRenderFns } from "./landing-preview.vue?vue&type=template&id=901b6420&scoped=true&lang=pug&"
import script from "./landing-preview.vue?vue&type=script&lang=js&"
export * from "./landing-preview.vue?vue&type=script&lang=js&"
import style0 from "./landing-preview.vue?vue&type=style&index=0&id=901b6420&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901b6420",
  null
  
)

export default component.exports